import { render, staticRenderFns } from "./Carriers.vue?vue&type=template&id=4f579605&scoped=true&"
import script from "./Carriers.vue?vue&type=script&lang=js&"
export * from "./Carriers.vue?vue&type=script&lang=js&"
import style0 from "./Carriers.vue?vue&type=style&index=0&id=4f579605&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f579605",
  null
  
)

export default component.exports